import { Divider } from 'antd';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ISubMenuItem } from '../CourseStepTab';
import { Wrapper } from '../CourseStepTab.styles';

import {
  OptionsWrapper,
  SubMenuItemWrapper,
  SubMenuTitleWrapper,
  SubMenuWrapper
} from './SubMenuTab.styles';

import { Icon } from '@/components/Icon';
import { useCourseDetail } from '@/store';
import { ECourseContentStep, ECourseStep } from '@/types';

type Props = {
  label: string;
  subMenuItems: ISubMenuItem[];
  isActive: boolean;
  onClick: () => void;
};

export const SubMenuTab: React.FC<Props> = ({ label, subMenuItems, isActive, onClick }) => {
  const { course } = useCourseDetail();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigateTo = useNavigate();

  const handleSubMenuClick = (key: ECourseContentStep) => {
    setIsOpen(prev => !prev);
    navigateTo({
      pathname: `${location.pathname}`,
      search: `?activeTab=${ECourseStep.CONTENT}&contentTab=${key}`
    });
    window.scrollTo(0, 0);
  };

  return (
    <SubMenuWrapper onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
      <Wrapper $isActive={isActive} onClick={onClick}>
        <span>{label}</span>
        <Icon i={'ChevronUp'} style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
      </Wrapper>
      {isOpen && (
        <OptionsWrapper key={label}>
          {subMenuItems.map((item, index) => {
            const isLast = index === subMenuItems.length - 1;
            const title =
              item.key === ECourseContentStep.COMPLEMENTARY_MATERIAL &&
              course?.complementaryMaterial?.title
                ? course.complementaryMaterial.title
                : item.label;
            return (
              <SubMenuItemWrapper key={`${item.key}-${index}`}>
                <SubMenuTitleWrapper onClick={() => handleSubMenuClick(item.key)}>
                  {`${index + 1}. ${title}`}
                </SubMenuTitleWrapper>
                {!isLast && <Divider />}
              </SubMenuItemWrapper>
            );
          })}
        </OptionsWrapper>
      )}
    </SubMenuWrapper>
  );
};
